import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UserService } from '../../../core/user/user.service';
import { AuthService } from '../auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const userService: UserService = inject(UserService);
  const authService: AuthService = inject(AuthService);

  function canAccessAuthenticatedRoute(url: string): boolean {
    const basePath = url.split('?')[0];

    // Rotas exclusivas de super usuários
    const onlySuperRoutes = ['/demo-list', '/companies', '/organizations', '/integrators', '/integrations'];

    // Rotas que precisam de companyId
    const routesNeedCompanyId = ['/cfg', '/dashboard', '/products', '/products/product-groups'];

    const demoViewerAllowedRoutes = ['/demo-list', '/sign-out'];

    const isOnlySuperRoute = onlySuperRoutes.includes(basePath);
    const isRouteNeedCompanyId = routesNeedCompanyId.includes(basePath);
    // ## DEVERIA ESTAR USANDO O STATE E NÃO DIRETO DA LOCALSTORAGE
    const user = userService.getUserFromLocalStorage();

    // Se há usuário logado
    if (user) {
      const hasCurrentCompany = !!user?.currentCompanyId;
      const hasSuperRole = user?.roles?.includes('SUPER');

      // Se for rota de super usuário e o usuário logado não for super, redirecionada para a rota padrão
      if (isOnlySuperRoute && !hasSuperRole) {
        router.navigate(['/']);
        return false;
      }

      // Se a rota precisa de companyId e o usuário não tem, redireciona para uma rota padrão que não necessita
      if (isRouteNeedCompanyId && !hasCurrentCompany) {
        router.navigate(['/companies']);
        return false;
      }
    }

    return true;
  }

  // Check the authentication status
  return authService.check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
      }

      if (!canAccessAuthenticatedRoute(state.url)) {
        return of(false);
      }

      return of(true);
    }),
  );
};
